<template>
  <withTopNav
    :leftText="agentLevel == undefined ? $t('Activities.Agentcenter.Income.AgentDetails') : $t('Activities.Agentcenter.Income.TeamList')"
    fixed
  >
    <div
      class="flex items-center justify-between text-[14px] text-white py-4 px-5 sticky top-0 z-[101]"
    >
      <div class="flex items-center justify-center">
        <span>{{ $t('Activities.Agentcenter.Income.SwipeTable') }}</span>
      </div>
      <div
        className="flex items-center justify-center"
        @click="() => (dateFilterModal = true)"
      >
        <span>{{ showTimeText }}</span>
        <img class="w-3 ml-1 rotate-90" :src="arrow_bai" alt="" />
      </div>
    </div>
    <van-pull-refresh
      :pulling-text="$t('Activities.Agentcenter.Income.PullToRefresh')"
      :loosing-text="$t('Activities.Agentcenter.Income.ReleaseToRefresh')"
      :loading-text="$t('Activities.Agentcenter.Income.Loading')"
      :success-text="$t('Activities.Agentcenter.Income.Success')"
      v-model="refreshing"
      @refresh="
        () => {
          agentList = [];
          queryReportList({ pageIndex: 1 });
        }
      "
    >
      <div class="px-5 w-full overflow-y-scroll">
        <div
          :style="{
            width: `${
              agentLevel == undefined
                ? columnsSelf.length * 119
                : columnsTeam.length * 119
            }px`,
          }"
        >
          <van-list
            v-model:loading="loading"
            :finished="finished"
            :loading-text="$t('Common.Loading')"
            @load="queryReportList"
          >
            <DataTable
              :columns="agentLevel == undefined ? columnsSelf : columnsTeamData"
              :round="true"
              :data="agentList"
            ></DataTable>
          </van-list>
        </div>
      </div>
    </van-pull-refresh>

    <van-popup
      v-model:show="dateFilterModal"
      position="bottom"
      class="w-full bg-[#151A1F] bottom-0 rounded-t-[24px]"
    >
      <div
        class="w-full h-[44px] text-[15px] flex justify-center items-center bg-[#2C7952]/70 text-[#fff] sticky top-0 rounded-t-[10px]"
      >
        <span>{{ $t('Activities.Agentcenter.Income.DateFilter') }}</span>
      </div>
      <p class="text-[#fff] text-[15px] mt-[10px] px-[20px]">
        {{ $t('Activities.Agentcenter.Income.FilterAgentRange') }}
      </p>
      <div class="px-[20px] flex justify-between flex-wrap mt-[10px] gap-y-[10px]">
        <button
          v-for="item in options"
          :key="item.value"
          @click="showTimeText = item.label"
          :class="[
            'w-[160px] h-[44px] text-[13px] rounded-[8px] border-0',
            showTimeText === item.label
              ? 'bg-[#2C7952]/40 text-[#fff]'
              : 'bg-[#2C7952]/20 text-[#fff]/65',
          ]"
        >
          {{ item.label }}
        </button>
      </div>

      <div class="mx-[30px] my-8">
        <PopupFooter
          :onCancel="() => (dateFilterModal = false)"
          :onConfirm="
            () => {
              dateFilterModal = false;
              const currentDate = options.find((item) => item.label === showTimeText);
              onChooseDateSearch(currentDate?.value);
            }
          "
        />
      </div>
    </van-popup>
  </withTopNav>
</template>

<script setup lang="tsx">
import PopupFooter from "@a/components/PopupFooter/index.vue";
import withTopNav from "@/layouts/withTopNav.vue";
import arrow_bai from "./../agentdetail/images/arrow_bai.png";
import DataTable from "@a/components/DataTable/index.vue";
import { getAgentOverview, getAgentTeamDetail } from "@/api/agent";
import { options, columnsSelf, columnsTeam } from "./config";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const agentLevel = useRoute().query.agentLevel;

const showTimeText = ref<any>(t('Activities.Agentcenter.Income.AllAgentEarnings'));
const dateFilterModal = ref<boolean>(false);
const agentList = ref<any[]>([]);
const loading = ref<boolean>(false);
const finished = ref<boolean>(false);
const refreshing = ref<boolean>(false);
const page = ref<number>(0);
const columnsTeamData = ref<any[]>([]);
const onChooseDateSearch = (selectType) => {
  const label = options.find((item) => item.value === selectType)?.label;
  agentList.value = [];
  queryReportList({
    pageIndex: 1,
    agentLevel: selectType,
  });
  showTimeText.value = label;
  dateFilterModal.value = false;
};
const queryReportList = async (props) => {
  const params = {
    pageIndex: page.value,
    pageSize: 10,
    agentLevel: agentLevel ? agentLevel : "All",
    ...props,
  };
  loading.value = true;
  let response;
  if (agentLevel) {
    response = await getAgentTeamDetail(params);
  } else {
    response = await getAgentOverview(params);
  }
  const { code, data } = response;
  loading.value = false;
  refreshing.value = false;
  finished.value = data.data.length < 10;
  if (code === 1) {
    page.value = data.page + 1;
    agentList.value = [...agentList.value, ...data.data];
  }
};

onMounted(() => {
  if (agentLevel) {
    const label = options.find((item) => item.value === agentLevel)?.label;
    showTimeText.value = label;
  }
  columnsTeamData.value = columnsTeam.map((column) => {
    if (column.key === "userid" || column.key === "parentId") {
      const originalRender: any = column.render;
      column.render = (row: any) => originalRender({ ...row, $router: useRouter() });
    }
    return column;
  });
});
</script>

<style scoped lang="scss"></style>
